export const PLATFORM_COLORS = {
  chatgpt: '#10a37f',
  claude: '#cc785c',
  perplexity: '#7c3aed',
  google: '#4285f4',
  gemini: '#34a853',
  copilot: '#0078d4',
  duckduckgo: '#de5833',
};

export const PLATFORM_NAMES = {
  chatgpt: 'ChatGPT',
  claude: 'Claude',
  perplexity: 'Perplexity',
  google: 'Google Search',
  gemini: 'Gemini',
  copilot: 'Microsoft Copilot',
  duckduckgo: 'DuckDuckGo',
};

export const BOT_COLORS = {
  GPTBot: '#10a37f',
  'ChatGPT-User': '#10a37f',
  ClaudeBot: '#cc785c',
  'anthropic-ai': '#cc785c',
  PerplexityBot: '#7c3aed',
  'Perplexity-User': '#7c3aed',
  Googlebot: '#4285f4',
  'Google-Extended': '#34a853',
  Applebot: '#555555',
  'cohere-ai': '#4f46e5',
  CCBot: '#888888',
  facebookexternalhit: '#1877f2',
  Bytespider: '#000000',
};
